module.exports = __webpack_public_path__ + "assets/0f3fae28d4815f7d435849052d25f4f8.png";